import {gql} from '@apollo/client'

export default gql`
  query getCurrentUser {
    currentUser {
      role
    }
  }
`